import { useContext } from 'react';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';
import { useContext as useContextWithSelector } from 'use-context-selector';

import {
  CatalogDataContextV2,
  CatalogDataContextWithSelector,
} from './CatalogDataContext.types';

export const useCatalogDataContext = () => {
  const hasCatalogDataContextWithSelector = useUserHasFeature(
    Feature.FEPerf_CatalogDataContextWithSelector
  );

  const context = useContext(CatalogDataContextV2);
  const contextWithSelector = useContextWithSelector(
    CatalogDataContextWithSelector
  );
  return hasCatalogDataContextWithSelector ? contextWithSelector : context;
};
